import { useEffect, useRef } from 'react';

function useWakeLock(cookMode) {
    
  const wakeLockRef = useRef(null);

  const release = () => {
    if (wakeLockRef.current !== null) {
      wakeLockRef.current.release();
      wakeLockRef.current = null;
      console.log('wakeLock released');
    }
  }

  const handleReFocus = async () => {
    if (cookMode) {
      const lock = await navigator.wakeLock.request('screen');
      wakeLockRef.current = lock;
      console.log('handle refocus')
    }
  }

  useEffect(() => {
    if ('wakeLock' in navigator) {

      const requestWakeLock = async () => {
        const lock = await navigator.wakeLock.request('screen');
        wakeLockRef.current = lock;
        console.log('wakelock on')
      };

      if (cookMode) {
        requestWakeLock();
      }

      window.addEventListener('blur', release);
      window.addEventListener('focus', handleReFocus);

      return () => {
        if (wakeLockRef.current) {
          release();
        }

        window.removeEventListener('blur', release);
        window.removeEventListener('focus', handleReFocus);
      };
    }
  }, [cookMode]);
}

export default useWakeLock;